module.exports = __webpack_public_path__ + "img/Ligue-1.9fe221dc.png";